import { WebsiteVersionG } from "@/features/website"

export const HomePage = () => {
  return <WebsiteVersionG />
}
